// Popper component cause a type error in production. This is the MUI bug.
// @ts-nocheck
import React, { useState, useRef, FC, Dispatch, SetStateAction } from 'react';
// mui components
import { ClickAwayListener, Grow, Paper, Typography, Grid, Button, Popper } from '@mui/material';
// components
import TagsSelect from './components/tags-select';
// api
import { IPhase, ITag } from 'redux-store/types';
// icons
import PlusIcon from 'assets/icons/buttons/plus.svg';
// styles
import { addTagButtonStyles } from './styles';

interface IAddTagButtonProps {
  phases: IPhase[];
  phaseValues: ITag[];
  phaseItemsValues: ITag[];
  setPhaseValues: Dispatch<SetStateAction<ITag[]>>;
  setPhaseItemsValues: Dispatch<SetStateAction<ITag[]>>;
  handleSubmitTags: (phaseIds: ITag[], phaseItemIds: ITag[]) => void;
  handleSetDefaultTags: () => void;
}

const TAGS_POPPER_Z_INDEX = 1500;

const AddTagButton: FC<IAddTagButtonProps> = ({
  phases,
  handleSubmitTags,
  phaseValues,
  phaseItemsValues,
  setPhaseValues,
  setPhaseItemsValues,
  handleSetDefaultTags,
}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const phaseItems = phases.map(({ items }) => items).flat();

  const phaseOptions: ITag[] = phases?.map(({ id, color, title }) => ({ id, color, title }));

  const phaseItemsOptions: ITag[] = phaseItems?.map(({ id, title }) => ({ id, title }));

  const onClear = () => {
    setPhaseValues([]);
    setPhaseItemsValues([]);
  };

  const handleToggle = () => {
    handleSetDefaultTags();
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = () => {
    handleSetDefaultTags();
    setOpen(false);
  };

  const handlePhasesChange = (selectedValues: ITag[]) => {
    setPhaseValues(selectedValues);
  };

  const handlePhaseItemsChange = (selectedValues: ITag[]) => {
    setPhaseItemsValues(selectedValues);
  };

  const handlePhaseDelete = (itemId: number) => {
    setPhaseValues((prev) => prev.filter(({ id }) => id !== itemId));
  };

  const handlePhaseItemsDelete = (itemId: number) => {
    setPhaseItemsValues((prev) => prev.filter(({ id }) => id !== itemId));
  };

  return (
    <Grid sx={addTagButtonStyles.container}>
      <Button
        ref={anchorRef}
        variant="text"
        id="tags-button"
        aria-controls={open ? 'tags-button' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        startIcon={<PlusIcon style={{ height: '16px', width: '16px' }} />}
        sx={addTagButtonStyles.button}
      >
        Add Tags
      </Button>

      <Popper
        transition
        open={open}
        role={undefined}
        placement="top-start"
        anchorEl={anchorRef.current}
        style={{
          zIndex: TAGS_POPPER_Z_INDEX,
        }}
        sx={{
          zIndex: TAGS_POPPER_Z_INDEX,
        }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper
              sx={{
                ...addTagButtonStyles.paper,
                position: 'relative',
                zIndex: TAGS_POPPER_Z_INDEX,
              }}
            >
              <ClickAwayListener onClickAway={handleClose}>
                <Grid sx={addTagButtonStyles.wrapper}>
                  <Grid sx={addTagButtonStyles.sectionsContainer}>
                    <Grid sx={addTagButtonStyles.titleContainer}>
                      <Typography sx={addTagButtonStyles.title}>Tags</Typography>
                    </Grid>

                    <Grid sx={addTagButtonStyles.selectsContainer}>
                      <Grid sx={addTagButtonStyles.phaseContainer}>
                        <Grid sx={addTagButtonStyles.phaseTextContainer}>
                          <Typography sx={addTagButtonStyles.selectTitle}>Phase</Typography>
                          <Typography sx={addTagButtonStyles.optional}>optional</Typography>
                        </Grid>
                        <Grid sx={addTagButtonStyles.phaseSelectContainer}>
                          <TagsSelect
                            placeholder="Select phase"
                            options={phaseOptions}
                            value={phaseValues}
                            handleChange={handlePhasesChange}
                            handleDelete={handlePhaseDelete}
                            type="phases"
                          />
                        </Grid>
                      </Grid>

                      <Grid sx={addTagButtonStyles.scheduleItemContainer}>
                        <Grid sx={addTagButtonStyles.scheduleItemTextContainer}>
                          <Typography sx={addTagButtonStyles.selectTitle}>Schedule item</Typography>
                          <Typography sx={addTagButtonStyles.optional}>optional</Typography>
                        </Grid>
                        <Grid sx={{ display: 'flex', width: '100%' }}>
                          <TagsSelect
                            placeholder="Select schedule item"
                            options={phaseItemsOptions}
                            value={phaseItemsValues}
                            handleChange={handlePhaseItemsChange}
                            handleDelete={handlePhaseItemsDelete}
                            type="phases"
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid sx={addTagButtonStyles.btnsContainer}>
                      <Button variant="text" onClick={onClear} sx={addTagButtonStyles.clearBtn}>
                        Clear All
                      </Button>
                      <Button
                        sx={addTagButtonStyles.doneBtn}
                        onClick={() => {
                          handleSubmitTags(phaseValues, phaseItemsValues);
                          handleClose();
                          handleSetDefaultTags();
                        }}
                      >
                        Done
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </Grid>
  );
};

export default AddTagButton;
